import { Receta } from "./Receta";

export default function ContenedorRecetas() {

    return (
        <section class="container-fluid recetas-container">
            <h2 class="text-light text-center py-5 fw-bold">Transformate en barman con las mejores recetas</h2>
            <div id="slider" class="carousel slide container" data-bs-ride="carousel">
                <div class="carousel-inner">
                    <div class="carousel-item active">
                        <div id="carousel-page-1" class="cards-wrapper recetas-wrapper">
                            <Receta />
                            <Receta />
                            <Receta />
                        </div>
                    </div>
                    <div class="carousel-item">
                        <div id="carousel-page-2" class="cards-wrapper recetas-wrapper">
                            <Receta />
                            <Receta />
                            <Receta />
                        </div>
                    </div>
                </div>
                <button class="carousel-control-prev" type="button" data-bs-target="#slider" data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                </button>
                <button class="carousel-control-next" type="button" data-bs-target="#slider" data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                </button>
            </div>
        </section>
    )
}


